import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/pages/Main";
import SubMain from "@/components/pages/SubMain";
import PageIndex from "@/components/pages/index/Index";
import PageDashboard from "@/components/pages/dashboard/Index";
import OrdersServiceIndex from "@/components/pages/orders/service/Index";
import OrdersServiceDetail from "@/components/pages/orders/service/Detail";
import OrdersServiceCreate from "@/components/pages/orders/service/Create";
import OrdersBeadhouseIndex from "@/components/pages/orders/beadhouse/Index";
import OrdersBeadhouseDetail from "@/components/pages/orders/beadhouse/Detail";
import OrdersBeadhouseCreate from "@/components/pages/orders/beadhouse/Create";
import OrdersDaycareIndex from "@/components/pages/orders/daycare/Index";
import OrdersDaycareDetail from "@/components/pages/orders/daycare/Detail";
import OrdersDaycareCreate from "@/components/pages/orders/daycare/Create";
import OrdersDinnerIndex from "@/components/pages/orders/dinner/Index";
import OrdersDinnerDetail from "@/components/pages/orders/dinner/Detail";
import OrdersDinnerCreate from "@/components/pages/orders/dinner/Create";
import WorkorderIndex from "@/components/pages/workorder/Index";
import WorkorderDetail from "@/components/pages/workorder/Detail";
import AlarmorderIndex from "@/components/pages/alarmorder/Index";
import AlarmorderDetail from "@/components/pages/alarmorder/Detail";
import PlanorderIndex from "@/components/pages/planorder/Index";
import PlanorderDetail from "@/components/pages/planorder/Detail";
import Login from "@/components/login/Login";

const olderIndex = () =>
  import("@/components/pages/men/index.vue");
const olderList = () =>
  import("@/components/pages/men/olderList.vue");
const olderDetail = () =>
  import("@/components/pages/men/detail/index.vue");
const baseInfo = () =>
  import("@/components/pages/men/detail/baseinfo/baseinfo.vue");
const ylService = () =>
  import("@/components/pages/men/detail/yanglao/ylservice.vue");
const ownaccount = () =>
  import("@/components/pages/men/detail/ownaccount/ownaccount.vue");
const serviceorder = () =>
  import("@/components/pages/men/detail/serviceorder/serviceorder.vue");
const evaluate = () =>
  import("@/components/pages/men/detail/evaluate/evaluate.vue");

const approveIndex = () =>
  import("@/components/pages/approve/index.vue");
const approveFaceList = () =>
  import("@/components/pages/approve/servicefacelist.vue");
const approveFaceDetail = () =>
  import("@/components/pages/approve/servicefacedetail.vue");
const recordList = () =>
  import("@/components/pages/record/list.vue");
const recordDetail = () =>
  import("@/components/pages/record/detail.vue");
// servicefacedetail

Vue.use(Router);

export default new Router({
  routes: [{
    path: "/",
    component: Main,
    meta: { auth: true },
    children: [{
      path: "",
      component: PageIndex
    },
    {
      path: "dashboard",
      component: PageDashboard
    },
    {
      path: "",
      component: SubMain,
      children: [
        {
          path: "orders/service",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "服务订单管理"
            }
            ]
          },
          component: OrdersServiceIndex
        },
        {
          path: "orders/service/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "服务订单详情"
            }
            ]
          },
          component: OrdersServiceDetail
        },
        {
          path: "orders/service/create",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "下单"
            }
            ]
          },
          component: OrdersServiceCreate
        },
        {
          path: "orders/beadhouse",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "养老机构订单管理"
            }
            ]
          },
          component: OrdersBeadhouseIndex
        },
        {
          path: "orders/beadhouse/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "养老机构订单详情"
            }
            ]
          },
          component: OrdersBeadhouseDetail
        },
        {
          path: "orders/beadhouse/create",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "下单"
            }
            ]
          },
          component: OrdersBeadhouseCreate
        },
        {
          path: "orders/daycare",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "日间照料中心订单管理"
            }
            ]
          },
          component: OrdersDaycareIndex
        },
        {
          path: "orders/daycare/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "日间照料中心订单详情"
            }
            ]
          },
          component: OrdersDaycareDetail
        },
        {
          path: "orders/daycare/create",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "下单"
            }
            ]
          },
          component: OrdersDaycareCreate
        },
        {
          path: "orders/dinner",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "送餐订单管理"
            }
            ]
          },
          component: OrdersDinnerIndex
        },
        {
          path: "orders/dinner/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "送餐订单详情"
            }
            ]
          },
          component: OrdersDinnerDetail
        },
        {
          path: "orders/dinner/create",
          meta: {
            breadcrumbs: [{
              name: "订单管理"
            },
            {
              name: "下单"
            }
            ]
          },
          component: OrdersDinnerCreate
        },
        {
          path: "orders/workorder",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "坐席工单管理"
            }
            ]
          },
          component: WorkorderIndex
        },
        {
          path: "orders/workorder/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "工单详情"
            }
            ]
          },
          component: WorkorderDetail
        },
        {
          path: "orders/planorder",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "计划工单管理"
            }
            ]
          },
          component: PlanorderIndex
        },
        {
          path: "orders/planorder/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "计划工单详情"
            }
            ]
          },
          component: PlanorderDetail
        },
        {
          path: "orders/alarmorder",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "报警工单管理"
            }
            ]
          },
          component: AlarmorderIndex
        },
        {
          path: "orders/alarmorder/detail",
          meta: {
            breadcrumbs: [{
              name: "工单管理"
            },
            {
              name: "报警工单详情"
            }
            ]
          },
          component: AlarmorderDetail
        }
      ]
    },
    {
      path: "record",
      component: SubMain,
      children: [{
        path: "recordList",
        component: recordList,
        meta: {
          breadcrumbs: [
            { name: "呼叫记录" },
            { name: "呼叫记录列表" }
          ]
        }
      }, {
        path: "recordDetail",
        component: recordDetail,
        meta: {
          breadcrumbs: [
            { name: "呼叫记录" },
            { name: "呼叫记录详情" }
          ]
        }
      }]
    },
    {
      path: "men",
      component: SubMain,
      children: [{
        path: "olderList",
        component: olderList,
        meta: {
          breadcrumbs: [{
            name: "服务对象管理"
          },
          {
            name: "所有老人"
          }
          ]
        }
      },
      {
        path: "olderList/detail",
        component: olderDetail,
        redirect: "olderList/detail/baseinfo",
        meta: {
          breadcrumbs: [
            { name: "服务对象管理" },
            { name: "老人详情" }
          ]
        },
        children: [{
          path: "baseinfo",
          name: "baseinfo",
          component: baseInfo,
          meta: {
            breadcrumbs: [
              { name: "服务对象管理" },
              { name: "老人详情" },
              { name: "基础信息" }
            ]
          }
        },
        {
          path: "ylservice",
          name: "ylservice",
          component: ylService,
          meta: {
            breadcrumbs: [
              { name: "服务对象管理" },
              { name: "老人详情" },
              { name: "养老服务" }
            ]
          }
        },
        {
          path: "ownaccount",
          name: "ownaccount",
          component: ownaccount,
          meta: {
            breadcrumbs: [
              { name: "服务对象管理" },
              { name: "老人详情" },
              { name: "钱包" }
            ]
          }
        },
        {
          path: "serviceorder",
          name: "serviceorder",
          component: serviceorder,
          meta: {
            breadcrumbs: [
              { name: "服务对象管理" },
              { name: "老人详情" },
              { name: "服务订单" }
            ]
          }
        },
        {
          path: "evaluate",
          name: "evaluate",
          component: evaluate,
          meta: {
            breadcrumbs: [
              { name: "服务对象管理" },
              { name: "老人详情" },
              { name: "评价" }
            ]
          }
        }
        ]
      }
      ]
    },
    //  approveIndex approveFaceList合登记/人脸信息申请登记/人脸信息登记列表
    {
      path: "approve",
      component: SubMain,
      children: [{
        path: "approveFaceList",
        component: approveFaceList,
        meta: {
          breadcrumbs: [{
            name: "综合登记"
          },
          {
            name: "人脸信息申请登记列表"
          }
          ]
        }
      },
      {
        path: "approveFaceList/detail",
        component: approveFaceDetail,
        // redirect: "approveFaceList/detail",
        meta: {
          breadcrumbs: [
            { name: "综合登记" },
            { name: "人脸信息登记详情" }
          ]
        }
      }
      ]
    }
    ]
  },
  {
    path: "/login",
    component: Login
  }
  ]
});